import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../contexts/auth";
import axios from "axios";
import { HiOutlineExclamationCircle } from "react-icons/hi";
import { Button } from "@mui/material";
import { GridOn, ViewList } from "@mui/icons-material";
import { Table } from "../../../components/Table";
import { Loader } from "../../../components/Loaders/loader";
import { Delete, Edit, Visibility } from "@mui/icons-material";
import DeleteCell from "../../../components/Layout/CellScope/DeleteCell/DeleteCell";
import Search from "../../../components/Search/Search";
import Filter from "../../../components/Filter/Filter";

export const ViewCellCategory = () => {
    const { role } = useAuth();
    const [currentPage, setCurrentPage] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [inventory, setInventory] = useState([]);
    const [batteries, setBatteries] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [viewMode, setViewMode] = useState("list");
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [batteryId, setbatteryId] = useState("");
    const navigate = useNavigate();

    const toggleViewMode = () => {
        setViewMode((prevMode) => (prevMode === "list" ? "grid" : "list"));
    };

    const handleOpen = () => {
        window.open("/auth/addCell", "_blank");
    };

    const editHandler = useCallback(
        (id) => {
            window.open(`/auth/addCell/${id}`, "_blank");
            // navigate(`/auth/addCell/${id}`);
        },
        [batteries],
    );


    useEffect(() => {
        const fetchInventory = async () => {
            setIsLoading(true);
            try {
                const response = await axios.get(`${process.env.BACKEND_URL}batteries/cell_categories`);
                const transformedResponse = response.data.map((item, i) => {
                    return {
                        _id: i + 1,
                        ...item.category,
                        count: item.count,
                        cell_image: item.cell_image
                    };
                });
                setInventory(transformedResponse);
                setFilteredData(transformedResponse);
                setIsLoading(false);
            } catch (error) {
                console.log(error);
                setIsLoading(false);
            }
        };
        fetchInventory();
    }, []);

    const columnDef = [
        {
            header: "Image",
            cell: (data) => {
                return (
                    <div className="flex gap-1 md:gap-2 align-center justify-center">
                        <img
                            src={`${process.env.BACKEND_URL}files/${data.row.original.cell_image}?thumb=1`}
                            alt="cellImage"
                            className="w-5 h-5 md:w-10 md:h-10"
                        />
                    </div>
                );
            },
        },
        {
            accessorKey: "manufacturer",
            header: "Manufacturer",
        },
        {
            accessorKey: "model",
            header: "Model",
        },
        {
            accessorKey: "type",
            header: "Type",
        },
        // {
        //     accessorKey: "capacity",
        //     header: "Capacity",
        // },
        // {
        //     accessorKey: "nominal_voltage",
        //     header: "Voltage",
        // },
        {
            accessorKey: "cell_condition",
            header: "Condition",
        },
        {
            accessorKey: "price",
            header: "Price",
        },
        {
            accessorKey: "count",
            header: "Quantity",
        },
    ];

    const columnDef2 = [
        {
            header: "Image",
            cell: (data) => {
                return (
                    <div className="flex gap-1 md:gap-2 align-center justify-center">
                        <img
                            src={`${process.env.BACKEND_URL}files/${data.row.original.cell_image}?thumb=1`}
                            alt="cellImage"
                            className="w-5 h-5 md:w-10 md:h-10"
                        />
                        <img
                            src={`${process.env.BACKEND_URL}files/barcode/${data.row.original.battery_id}`}
                            alt="barcode"
                            className="w-5 h-5 md:w-10 md:h-10"
                        />
                    </div>
                );
            },
        },
        {
            accessorKey: "meta.manufacturer",
            header: "Manufacturer",
        },
        {
            accessorKey: "meta.model",
            header: "Model",
        },
        {
            accessorKey: "meta.type",
            header: "Type",
        },
        {
            accessorKey: "electrical_properties.capacity",
            header: "Capacity",
        },
        {
            accessorKey: "electrical_properties.nominal_voltage",
            header: "Voltage",
        },
        {
            accessorKey: "meta.soh",
            header: "SoH",
        },
        {
            accessorKey: "meta.price",
            header: "Price",
        },
        {
            accessorKey: "actions",
            header: "Actions",
            cell: (data) => {
                return (
                    <div className="flex gap-2">

                        {role === "admin" && (
                            <>
                                <Visibility
                                    cursor="pointer"
                                    onClick={() => handleShowDetails(data.row.original._id)}
                                >
                                    Show Details
                                </Visibility>
                                <Edit
                                    color="info"
                                    cursor="pointer"
                                    onClick={() => editHandler(data.row.original._id)}
                                >
                                    Edit
                                </Edit>
                                <Delete
                                    color="error"
                                    cursor="pointer"
                                    onClick={() => { setbatteryId(data.row.original._id), setOpenDeleteModal(true) }}
                                >
                                    Delete
                                </Delete>
                            </>
                        )}

                    </div>
                );
            },
        },
    ];

    const handleShowDetailsRow = (id) => {
        const selectedCell = inventory.find((cell) => cell._id === id);
        const fetchCategoryInventory = async () => {
            setIsLoading(true);
            try {
                const response = await axios.post(`${process.env.BACKEND_URL}batteries/cell_category`, {
                    manufacturer: selectedCell.manufacturer,
                    model: selectedCell.model,
                    cell_condition: selectedCell.cell_condition,
                    price: selectedCell.price,
                });
                if(response.data.length === 0) {
                    setIsLoading(false);
                    return;
                }else{
                    setBatteries(response.data);
                    setIsLoading(false);
                }
                setBatteries(response.data);
                setIsLoading(false);
            } catch (error) {
                console.log(error);
                setIsLoading(false);
            }
        };
        fetchCategoryInventory();
    };

    const removeFromList = (id) => {
        const updatedData = data.filter((cell) => cell._id !== id);
        setBatteries(updatedData);
      };    

    const handleShowDetails = useCallback(
        (id) => {
            window.open(`/auth/cellStore/${id}`, "_blank");
        },
        [navigate],
    );

    const handleShowDetailsUser = useCallback(
        (id) => {
            if (role !== "admin") {
                window.open(`/auth/cellStore/${id}`, "_blank");
            }
        },
        [navigate],
    );

    const gridDeleteHandler = (id) => {
        setbatteryId(id);
        setOpenDeleteModal(true);
    };

    return (
        <>
            {isLoading ? (
                <Loader />
            ) : (
                <div className="text-white pt-4 flex flex-col gap-10 items-center justify-center">
                    <h1 className="text-xl text-[#e8442d] text-center md:text-2xl lg:text-4xl">
                        CellScope: Cell Store powered by SoH data
                    </h1>
                    {batteries && batteries.length > 0 ? (
                        <div className="flex flex-col gap-7 items-center justify-center w-[85%]">
                            {role === "admin" && (
                                <p
                                    className="text-[#e8442d] text-sm md:text-xl cursor-pointer hover:text-[#e85d01] underline md:underline-offset-8"
                                    onClick={() => setBatteries([])}
                                >
                                    Go Back to Inventory
                                </p>
                            )}
                            <div className="w-[100%] flex flex-row justify-between">
                                {role === "admin" ? (
                                    <div className="w-[100%] flex flex-row items-center gap-5 my-0 md:my-1">
                                        <Button
                                            variant="contained"
                                            className="md:w-[20%] w-[80%] text-xs md:text-sm"
                                            sx={{
                                                backgroundColor: "#e8442d",
                                                fontFamily: "Bai Jamjuree",
                                                "&:hover": {
                                                    backgroundColor: "#e85d01",
                                                },
                                                "&:active": {
                                                    backgroundColor: "#e85d01",
                                                },
                                            }}
                                            onClick={handleOpen}
                                        >
                                            Add Cell
                                        </Button>
                                    </div>
                                ) : (
                                    <div className="flex flex-row items-center">
                                        <p
                                            className="text-[#e8442d] text-sm md:text-xl cursor-pointer hover:text-[#e85d01] underline md:underline-offset-8"
                                            onClick={() => setBatteries([])}
                                        >
                                            Go back to Categories
                                        </p>
                                    </div>
                                )}
                                <div className="flex items-center border border-gray-300 rounded-[50px] bg-[#f9f9f9] ml-7 h-[max-content]">
                                    <div
                                        className={`hover:bg-[#e8432d51] hover:text-white rounded-l-[50px] cursor-pointer ${viewMode === "grid" ? "bg-[#e8432d7b]" : ""}`}
                                        onClick={toggleViewMode}
                                    >
                                        <GridOn className="cursor-pointer my-1 mx-2 md:my-3 md:mx-4" />
                                    </div>
                                    <div className="border-r border-gray-300 h-full"></div>
                                    <div
                                        className={`hover:bg-[#e8432d51] hover:text-white rounded-r-[50px] cursor-pointer ${viewMode === "list" ? "bg-[#e8432d7b]" : ""}`}
                                        onClick={toggleViewMode}
                                    >
                                        <ViewList className="cursor-pointer my-1 mx-2 md:my-3 md:mx-4" />
                                    </div>
                                </div>
                            </div>
                            {/* go to category button */}
                            <Table
                                columns={role === "admin" ? columnDef2 : columnDef2.filter((col) => col.accessorKey !== "actions")}
                                currentPage={currentPage}
                                data={batteries}
                                loadingData={false}
                                setCurrentPage={setCurrentPage}
                                onRowClick={handleShowDetailsUser}
                                viewMode={viewMode}
                                // onRowClick={handleShowDetailsRow}
                                viewHandler={handleShowDetails}
                                editHandler={editHandler}
                                deleteHandler={gridDeleteHandler}
                                isEditable={role === "admin"}
                            />
                            <DeleteCell openDeleteModal={openDeleteModal} onDelete={removeFromList} batteryId={batteryId} setOpenDeleteModal={setOpenDeleteModal} />
                        </div>
                    ) : (
                        <>
                            {/* <div className="flex flex-row items-center justify-center">
                                <Button
                                    variant="contained"
                                    className="w-[100%]"
                                    sx={{
                                        backgroundColor: "#e8442d",
                                        fontFamily: "Bai Jamjuree",
                                        "&:hover": {
                                            backgroundColor: "#e85d01",
                                        },
                                        "&:active": {
                                            backgroundColor: "#e85d01",
                                        },
                                    }}
                                    onClick={() => navigate("/auth/cellscope/all")}
                                >
                                    View all Cells
                                </Button>
                            </div> */}
                            {inventory && inventory.length > 0 ? (
                                <div className="flex flex-col gap-7 items-center justify-center w-[85%]">
                                    <Search searchData={inventory} showDetails={handleShowDetailsRow} />
                                    <Filter data={inventory} setFilteredData={setFilteredData} />
                                    <div className="w-[100%] flex flex-row justify-between">
                                        {role === "admin" ? (
                                            <div className="w-[100%] flex flex-row items-center gap-5 my-0 md:my-1">
                                                <Button
                                                    variant="contained"
                                                    className="md:w-[20%] w-[80%] text-xs md:text-sm"
                                                    sx={{
                                                        backgroundColor: "#e8442d",
                                                        fontFamily: "Bai Jamjuree",
                                                        "&:hover": {
                                                            backgroundColor: "#e85d01",
                                                        },
                                                        "&:active": {
                                                            backgroundColor: "#e85d01",
                                                        },
                                                    }}
                                                    onClick={handleOpen}
                                                >
                                                    Add Cell
                                                </Button>
                                            </div>
                                        ) : (
                                            <div className="flex flex-row items-center">
                                            </div>
                                        )}
                                        <div className="flex items-center border border-gray-300 rounded-[50px] bg-[#f9f9f9] ml-7 h-[max-content]">
                                            <div
                                                className={`hover:bg-[#e8432d51] hover:text-white rounded-l-[50px] cursor-pointer ${viewMode === "grid" ? "bg-[#e8432d7b]" : ""}`}
                                                onClick={toggleViewMode}
                                            >
                                                <GridOn className="cursor-pointer my-1 mx-2 md:my-3 md:mx-4" />
                                            </div>
                                            <div className="border-r border-gray-300 h-full"></div>
                                            <div
                                                className={`hover:bg-[#e8432d51] hover:text-white rounded-r-[50px] cursor-pointer ${viewMode === "list" ? "bg-[#e8432d7b]" : ""}`}
                                                onClick={toggleViewMode}
                                            >
                                                <ViewList className="cursor-pointer my-1 mx-2 md:my-3 md:mx-4" />
                                            </div>
                                        </div>
                                    </div>
                                    <Table
                                        columns={columnDef}
                                        currentPage={currentPage}
                                        data={filteredData}
                                        loadingData={false}
                                        onRowClick={handleShowDetailsRow}
                                        setCurrentPage={setCurrentPage}
                                        viewMode={viewMode}
                                        viewHandler={handleShowDetailsRow}
                                    />
                                    {/* </div> */}
                                </div>
                            ) : (
                                <div className="flex flex-col text-center h-[35vh] items-center justify-center border-2 border-[#e8432d4e] rounded-lg p-4 w-full md:w-1/2">
                                    <HiOutlineExclamationCircle size="2em" className="text-[#e8442d] mb-2" />
                                    No such data found
                                </div>
                            )}
                        </>
                    )}
                    <div className="text-white pt-4 flex flex-col gap-12 items-center justify-center">
                        <h1 className="text-xl text-[#e8442d] text-center md:text-2xl lg:text-4xl">
                            What is CellScope?
                        </h1>
                        <p className="text-sm  md:text-lg lg:text-xl w-[85%] text-justify">
                            CellScope offers a wide range of services for battery cells. Our Cell store contains a
                            large number of fully characterized Cells, and our CellScope engine will fetch the
                            most-uniform bunch of cells for your Battery configuration along with all the SoH data
                            we have collected for each cell. This will make your life easy by taking away the pain
                            of doing laborious cell-matching before connecting them together into your pack.
                        </p>
                        <p className="text-sm  md:text-lg lg:text-xl w-[85%] text-justify">
                            We are also proud to offer recycled cells (with fully traceable SoH characterization
                            data) through our CellScope powered marketplace at a bargain price. These cells are
                            sourced from retired EV batteries and other e-waste and they are thoroughly assessed
                            for their state-of-health in our lab. Generally, EV batteries are retired after
                            depletion of around 25% battery life, and they offer a good value for second-life
                            applications life energy storage. Our marketplace aims to establish a circular economy
                            for battery cells in order to save our planet.
                        </p>
                    </div>
                </div>
            )}
        </>
    );
};
